import React, { useState, useEffect } from 'react';
import { professionalsAPI, servicesAPI } from '../services/api';
import useIsMobile from '../hooks/useIsMobile';
import toast from 'react-hot-toast';

const S = {
  eyebrow: { fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.8px', color: '#e97117', marginBottom: '6px' },
  h1: { fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800, textTransform: 'uppercase', lineHeight: 0.95, letterSpacing: '-0.02em', margin: 0, color: '#14562e' },
  subtitle: { color: '#6a7268', margin: '6px 0 0', fontSize: '15px' },
  card: { background: '#fff', border: '1px solid #e5ddc9', borderRadius: '16px', padding: '24px' },
  cardTitle: { fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800, textTransform: 'uppercase', fontSize: '15px', color: '#14562e', margin: '0 0 16px' },
  label: { fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px', color: '#6a7268', marginBottom: '6px', display: 'block' },
  input: { width: '100%', padding: '12px 14px', borderRadius: '10px', border: '1.5px solid #e5ddc9', background: '#f4ede0', color: '#183d24', fontFamily: "'DM Sans', sans-serif", fontSize: '14.5px', outline: 'none', boxSizing: 'border-box' },
  btn: { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '12px 22px', borderRadius: '12px', fontWeight: 700, fontSize: '14px', cursor: 'pointer', border: 'none', fontFamily: "'DM Sans', sans-serif", transition: 'all 0.15s' },
  pendingCard: { background: '#fff', border: '1px solid #e5ddc9', borderRadius: '16px', padding: '20px', marginBottom: '12px', transition: 'transform 0.15s' },
  pendingHead: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' },
  pendingTitle: { fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700, fontSize: '16px', color: '#14562e', margin: 0 },
  pendingMeta: { fontSize: '13px', color: '#6a7268', marginTop: '4px' },
  pendingActions: { display: 'flex', gap: '8px', marginTop: '12px' },
  tabRow: { display: 'flex', gap: '4px', background: '#f4ede0', borderRadius: '12px', padding: '4px', marginBottom: '24px' },
  tab: { flex: 1, padding: '10px 16px', borderRadius: '10px', border: 'none', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: '14px', textAlign: 'center', transition: 'all 0.15s' },
};

const SPECIALTIES = [
  { value: 'geral', label: 'Mecânica Geral' },
  { value: 'eletrica', label: 'Elétrica' },
  { value: 'funilaria', label: 'Funilaria e Pintura' },
  { value: 'pneus', label: 'Pneus e Alinhamento' },
  { value: 'revisao', label: 'Revisão e Diagnóstico' },
  { value: 'motos', label: 'Motos' },
  { value: 'diesel', label: 'Diesel' },
];

const STATES = ['AC','AL','AM','AP','BA','CE','DF','ES','GO','MA','MG','MS','MT','PA','PB','PE','PI','PR','RJ','RN','RO','RR','RS','SC','SE','SP','TO'];

function PendingCard({ service, onValidate, onReject }) {
  return (
    <div style={S.pendingCard}>
      <div style={S.pendingHead}>
        <div>
          <h4 style={S.pendingTitle}>{service.service_type_name || service.custom_service_name || 'Serviço'}</h4>
          <p style={S.pendingMeta}>
            🚗 {service.brand} {service.model} {service.year} {service.plate && `· ${service.plate}`}
          </p>
          <p style={S.pendingMeta}>
            👤 {service.owner_name} · {service.performed_at ? new Date(service.performed_at).toLocaleDateString('pt-BR') : '—'} · {(service.km_at_service || 0).toLocaleString('pt-BR')} km
          </p>
          {service.cost && <p style={S.pendingMeta}>💰 R$ {Number(service.cost).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</p>}
          {service.notes && <p style={{ ...S.pendingMeta, fontStyle: 'italic', marginTop: '6px' }}>"{service.notes}"</p>}
        </div>
        <span style={{ background: '#fdece0', color: '#e97117', padding: '4px 10px', borderRadius: '999px', fontSize: '11px', fontWeight: 700, textTransform: 'uppercase' }}>Pendente</span>
      </div>
      <div style={S.pendingActions}>
        <button style={{ ...S.btn, background: '#14562e', color: '#fff', flex: 1 }} onClick={onValidate}
          onMouseOver={e => { e.currentTarget.style.background = '#1a6b3a'; }}
          onMouseOut={e => { e.currentTarget.style.background = '#14562e'; }}>
          ✓ Validar serviço
        </button>
        <button style={{ ...S.btn, background: 'transparent', color: '#c94a2f', border: '1.5px solid #e5ddc9' }} onClick={onReject}
          onMouseOver={e => { e.currentTarget.style.borderColor = '#c94a2f'; }}
          onMouseOut={e => { e.currentTarget.style.borderColor = '#e5ddc9'; }}>
          Rejeitar
        </button>
      </div>
    </div>
  );
}

function ProfileTab({ profile, onSaved }) {
  const [form, setForm] = useState({
    business_name: '', description: '', specialty: 'geral', whatsapp: '',
    address_street: '', address_number: '', address_city: '', address_state: '', address_zip: '',
  });
  const [saving, setSaving] = useState(false);
  const m = useIsMobile();

  useEffect(() => {
    if (profile) {
      setForm({
        business_name: profile.business_name || '',
        description: profile.description || '',
        specialty: profile.specialty || 'geral',
        whatsapp: profile.whatsapp || '',
        address_street: profile.address_street || '',
        address_number: profile.address_number || '',
        address_city: profile.address_city || '',
        address_state: profile.address_state || '',
        address_zip: profile.address_zip || '',
      });
    }
  }, [profile]);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSave = async () => {
    if (!form.business_name) { toast.error('Nome da oficina é obrigatório'); return; }
    if (!form.address_city || !form.address_state) { toast.error('Cidade e estado são obrigatórios'); return; }
    setSaving(true);
    try {
      const r = await professionalsAPI.updateMe(form);
      toast.success('Perfil atualizado! ✓');
      onSaved?.(r.professional);
    } catch (err) { toast.error(err.message || 'Erro ao salvar'); }
    finally { setSaving(false); }
  };

  return (
    <div style={S.card}>
      <h3 style={S.cardTitle}>Dados da oficina</h3>

      <div style={{ display: 'grid', gridTemplateColumns: m ? '1fr' : '1fr 1fr', gap: '14px' }}>
        <div style={{ gridColumn: m ? '1' : '1 / -1' }}>
          <label style={S.label}>Nome da oficina / razão social</label>
          <input style={S.input} value={form.business_name} onChange={e => set('business_name', e.target.value)} placeholder="Auto Center Silva" />
        </div>
        <div>
          <label style={S.label}>Especialidade</label>
          <select style={S.input} value={form.specialty} onChange={e => set('specialty', e.target.value)}>
            {SPECIALTIES.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
          </select>
        </div>
        <div>
          <label style={S.label}>WhatsApp</label>
          <input style={S.input} value={form.whatsapp} onChange={e => set('whatsapp', e.target.value)} placeholder="(21) 99999-9999" />
        </div>
        <div style={{ gridColumn: m ? '1' : '1 / -1' }}>
          <label style={S.label}>Descrição</label>
          <textarea style={{ ...S.input, minHeight: '70px', resize: 'vertical' }} value={form.description} onChange={e => set('description', e.target.value)} placeholder="Mecânica especializada em veículos japoneses..." />
        </div>
      </div>

      <h3 style={{ ...S.cardTitle, marginTop: '24px' }}>Endereço</h3>
      <div style={{ display: 'grid', gridTemplateColumns: m ? '1fr' : '2fr 1fr', gap: '14px' }}>
        <div>
          <label style={S.label}>Rua</label>
          <input style={S.input} value={form.address_street} onChange={e => set('address_street', e.target.value)} placeholder="Av. Brasil" />
        </div>
        <div>
          <label style={S.label}>Número</label>
          <input style={S.input} value={form.address_number} onChange={e => set('address_number', e.target.value)} placeholder="1234" />
        </div>
        <div>
          <label style={S.label}>Cidade</label>
          <input style={S.input} value={form.address_city} onChange={e => set('address_city', e.target.value)} placeholder="Rio de Janeiro" />
        </div>
        <div>
          <label style={S.label}>Estado</label>
          <select style={S.input} value={form.address_state} onChange={e => set('address_state', e.target.value)}>
            <option value="">UF</option>
            {STATES.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
        <div>
          <label style={S.label}>CEP</label>
          <input style={S.input} value={form.address_zip} onChange={e => set('address_zip', e.target.value)} placeholder="20000-000" />
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
        <button style={{ ...S.btn, background: '#14562e', color: '#fff', opacity: saving ? 0.6 : 1 }} onClick={handleSave} disabled={saving}>
          {saving ? 'Salvando...' : 'Salvar alterações'}
        </button>
      </div>
    </div>
  );
}

export default function ProDashboard() {
  const [tab, setTab] = useState('pending');
  const [profile, setProfile] = useState(null);
  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pendingCount, setPendingCount] = useState(0);
  const m = useIsMobile();

  const loadData = async () => {
    try {
      const [meRes, pendRes] = await Promise.all([
        professionalsAPI.me().catch(() => null),
        professionalsAPI.pending().catch(() => ({ services: [] })),
      ]);
      if (meRes?.professional) setProfile(meRes.professional);
      setPending(pendRes.services || []);
      setPendingCount((pendRes.services || []).length);
    } catch {} finally { setLoading(false); }
  };

  useEffect(() => { loadData(); }, []);

  const handleValidate = async (serviceId) => {
    try {
      await servicesAPI.validate(serviceId, 'validate');
      toast.success('Serviço validado! ✓');
      loadData();
    } catch (err) { toast.error(err.message || 'Erro ao validar'); }
  };

  const handleReject = async (serviceId) => {
    try {
      await servicesAPI.validate(serviceId, 'reject');
      toast('Serviço rejeitado', { icon: '❌' });
      loadData();
    } catch (err) { toast.error(err.message || 'Erro ao rejeitar'); }
  };

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh', flexDirection: 'column', gap: '12px' }}>
      <div className="spinner" style={{ width: '32px', height: '32px' }} />
    </div>
  );

  return (
    <div>
      <div style={{ marginBottom: '4px' }}>
        <span style={S.eyebrow}>Painel profissional</span>
        <h1 style={{ ...S.h1, fontSize: m ? '28px' : '38px' }}>
          {profile?.business_name || 'Minha oficina'}
        </h1>
        <p style={S.subtitle}>
          {profile?.is_verified
            ? '✓ Verificado pela rede NICO'
            : 'Gerencie seus serviços e dados da oficina'}
        </p>
      </div>

      {/* Tabs */}
      <div style={S.tabRow}>
        <button
          style={{ ...S.tab, background: tab === 'pending' ? '#fff' : 'transparent', color: tab === 'pending' ? '#14562e' : '#6a7268', boxShadow: tab === 'pending' ? '0 1px 4px rgba(0,0,0,.1)' : 'none' }}
          onClick={() => setTab('pending')}>
          🔔 Pendentes {pendingCount > 0 && <span style={{ background: '#e97117', color: '#fff', padding: '2px 7px', borderRadius: '999px', fontSize: '11px', fontWeight: 700, marginLeft: '6px' }}>{pendingCount}</span>}
        </button>
        <button
          style={{ ...S.tab, background: tab === 'profile' ? '#fff' : 'transparent', color: tab === 'profile' ? '#14562e' : '#6a7268', boxShadow: tab === 'profile' ? '0 1px 4px rgba(0,0,0,.1)' : 'none' }}
          onClick={() => setTab('profile')}>
          🏪 Dados da oficina
        </button>
      </div>

      {/* Content */}
      {tab === 'pending' && (
        <div>
          {pending.length === 0 ? (
            <div style={{ ...S.card, textAlign: 'center', padding: '48px 24px' }}>
              <div style={{ fontSize: '44px', opacity: 0.3, marginBottom: '12px' }}>✅</div>
              <h3 style={{ fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700, fontSize: '18px', color: '#14562e', marginBottom: '8px' }}>Nenhum serviço pendente</h3>
              <p style={{ color: '#6a7268', fontSize: '14px', margin: 0 }}>Quando um cliente registrar um serviço com sua oficina, ele aparecerá aqui para validação.</p>
            </div>
          ) : (
            pending.map(s => (
              <PendingCard
                key={s.id}
                service={s}
                onValidate={() => handleValidate(s.id)}
                onReject={() => handleReject(s.id)}
              />
            ))
          )}
        </div>
      )}

      {tab === 'profile' && (
        <ProfileTab profile={profile} onSaved={p => setProfile(p)} />
      )}
    </div>
  );
}
